import SelectMenu from "../../../controls/SelectMenu";
import SalesPeriodDateRange from "./SalesPeriodDateRange";

export default function SalesComparisonReportFilter(props) {
  const { filters, setFilters, classes, categories } = props;
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-3 items-end">
      <SalesPeriodDateRange
        period={2}
        className="sm:col-span-2"
        startDate={filters.startDate2}
        startDateName="startDate2"
        endDate={filters.endDate2}
        endDateName="endDate2"
        onChange={(name, value) =>
          setFilters({
            ...filters,
            [name]: value,
          })
        }
        resetFilter={() =>
          setFilters({
            ...filters,
            startDate2: null,
            endDate2: null,
          })
        }
        maxDate={new Date()}
      />
      <SelectMenu
        title="Class"
        handleInputChange={(e) =>
          setFilters({ ...filters, class: e.target.value })
        }
        name="class"
        options={classes}
        value={filters.class}
      />
      <SelectMenu
        title="Category"
        handleInputChange={(e) =>
          setFilters({ ...filters, category: e.target.value })
        }
        name="category"
        options={categories}
        value={filters.category}
        disabled={filters.class.value === -1}
      />
    </div>
  );
}
